export default {
    init() {
        // JavaScript to be fired for the hero image

        /**
         * Hero image fade in
         */
        document.addEventListener("DOMContentLoaded", () => {
            const targetClass = '.hero--image > .bg-image'
            const hero = document.querySelector(targetClass);
            if (!hero) return;

            const bgUrl = getComputedStyle(hero).backgroundImage.match(/url\((['"]?)(.*?)\1\)/);
            if (bgUrl) fadeInBg(hero, bgUrl[2]);
        });

        function fadeInBg(el, url) {
            const img = new Image();
            img.onload = () => {
                el.style.backgroundImage = `url("${url}")`;
                el.classList.add("bg-loaded");
            };
            img.src = url;
        }
    },
};
